var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurguer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.16667C0 0.521354 0.510714 0 1.14286 0H14.8571C15.4893 0 16 0.521354 16 1.16667C16 1.81198 15.4893 2.33333 14.8571 2.33333H1.14286C0.510714 2.33333 0 1.81198 0 1.16667ZM0 7C0 6.35469 0.510714 5.83333 1.14286 5.83333H14.8571C15.4893 5.83333 16 6.35469 16 7C16 7.64531 15.4893 8.16667 14.8571 8.16667H1.14286C0.510714 8.16667 0 7.64531 0 7ZM16 12.8333C16 13.4786 15.4893 14 14.8571 14H1.14286C0.510714 14 0 13.4786 0 12.8333C0 12.188 0.510714 11.6667 1.14286 11.6667H14.8571C15.4893 11.6667 16 12.188 16 12.8333Z",
    fill: "#6B9CEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurguer);
export default __webpack_public_path__ + "static/media/burguer.ad90ba9ecacea7ce7fc628a05c853620.svg";
export { ForwardRef as ReactComponent };